<template>
  <div class="text-center row">
    <ul class="pagination " v-if="pager" style="margin-bottom: 2px;">
      <li class="footable-page-arrow" v-if="pager.current>1"><a v-on:click="clickPager(1)">«</a></li>
      <li class="footable-page-arrow" v-if="pager.current>1"><a v-on:click="clickPager(Number(pager.current)-1)">‹</a>
      </li>
      <template v-for="page in pager.children">
        <li class="footable-page active" v-show="page == pager.current"><a v-on:click="clickPager(page)">{{page}}</a>
        </li>
        <li class="footable-page" v-show="page != pager.current"><a v-on:click="clickPager(page)">{{page}}</a>
        </li>
      </template>
      <li class="footable-page-arrow" v-if="pager.current<pager.last"><a
        v-on:click="clickPager(Number(pager.current)+1)">›</a>
      </li>
      <li class="footable-page-arrow" v-if="pager.current<pager.last"><a
        v-on:click="clickPager(pager.last)">»</a>
      </li>
    </ul>
    <div>
      <small>View {{pager.view}} of {{pager.count}}</small>
    </div>

  </div>
</template>

<script>
  export default {
    props: ['pager'],
    methods: {
      clickPager: function (page) {
        this.$emit('click', page)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Pager.vue?51c7abc4